import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import keycode from 'keycode';
import Table, {
    TableBody,
    TableCell,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
} from 'material-ui/Table';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import Paper from 'material-ui/Paper';
import Checkbox from 'material-ui/Checkbox';
import IconButton from 'material-ui/IconButton';
import Tooltip from 'material-ui/Tooltip';
import DeleteIcon from 'material-ui-icons/Delete';
import { SpeakerNotes } from 'material-ui-icons'
import Menu, { MenuItem } from 'material-ui/Menu';
import { withRouter } from "react-router-dom";
import moment from 'moment'

import * as agendaitemdetails from '../../../actions/agendaitemdetails';

import AgendaNotes from './agendanotes'
import DeleteAgendaItem from './deleteagendaitem'

class CardMenu extends React.Component {

    render() {
        const ITEM_HEIGHT = 40;
        const options = [
            { id: 1, name: 'View / Update' },
            { id: 2, name: 'Delete' },
        ];
        const { menuState, anchorEl, handleRequestClose } = this.props;
        return (
            <Menu id="long-menu"
                anchorEl={anchorEl}
                open={menuState}
                onClose={handleRequestClose}
                style={{ maxHeight: ITEM_HEIGHT * 4.5 }}
                MenuListProps={{
                    style: {
                        width: 150,
                        paddingTop: 0,
                        paddingBottom: 0
                    },
                }}>
                {options.map(option =>
                    <MenuItem key={option.id} onClick={handleRequestClose.bind(this, option.id)}>
                        {option.name}
                    </MenuItem>,
                )}
            </Menu>
        );
    }

}

const columnData = [
    { id: 'smeetingId', numeric: false, disablePadding: false, label: 'S.No.' },
    { id: 'agenda', numeric: false, disablePadding: true, label: 'Agenda Item Name' },
    { id: 'headed_by', numeric: false, disablePadding: true, label: 'Headed By' },
    { id: 'created_on', numeric: false, disablePadding: true, label: 'Created Date' },
    { id: 'priority', numeric: false, disablePadding: true, label: 'Priority' },
    { id: 'action', numeric: false, disablePadding: true, label: 'Actions' },
    { id: 'notes', numeric: false, disablePadding: true, label: 'Notes' },
    
];

class DataTableHead extends React.Component {
    static propTypes = {
        onRequestSort: PropTypes.func.isRequired,
        order: PropTypes.string.isRequired,
        orderBy: PropTypes.string.isRequired,
    };

    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };

    render() {
        const { order, orderBy, numSelected, rowCount } = this.props;

        return (
            <TableHead>
                <TableRow>
                    {columnData.map(column => {
                        return (
                            <TableCell
                                key={column.id}
                                numeric={column.numeric}
                                padding={column.disablePadding ? 'none' : 'checkbox'}
                            >
                                <Tooltip
                                    title="Sort"
                                    placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === column.id}
                                        direction={order}
                                        onClick={this.createSortHandler(column.id)}
                                    >
                                        {column.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}

class DataTable extends React.Component {
    handleRequestSort = (event, property) => {
        // console.log('sort property',property)
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }
        // console.log('this.state.data',this.state.data)

        const data =
            order === 'desc'
                ? this.state.data.sort((a, b) => (b[orderBy] < a[orderBy] ? -1 : 1))
                : this.state.data.sort((a, b) => (a[orderBy] < b[orderBy] ? -1 : 1));

        this.setState({ data, order, orderBy });
    };
    handleChangePage = (event, page) => {
        this.setState({ page });
    };
    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    openNotes = (data) => {
        // console.log('openNotes', data);
        // this.state.agendaitem = data;
        // console.log('handleClick Notes', this.state.agendaitem);
        this.setState({ agendaitem: data, openNotesDialog: true });
        // console.log('handleClick Notes1', this.state.agendaitem);
    };
    onOptionMenuSelect = (data, event) => {
        console.log('onOptionMenuSelect', data);
        this.state.agendaitem = data;
        this.setState({ agendaitem: data, menuState: true, anchorEl: event.currentTarget });
    };
    handleRequestClose(data, click_id, e) {
        // console.log('handleClick', click_id);
        // console.log('data', data)
        if (click_id == 1) {
            // console.log('this.state.open out1', this.state.openDialog);
            // this.props.actions.setAgendaItemDetails(data);
            this.props.history.push('/agenda/add-agenda-item/' + data.id + '/' + data.undercommittee);
        }
        else if (click_id == 2) {
            this.setState({ openDeleteDialog: true });
        }
        else if (click_id == 3) {
            // this.setState({open: true});
        }
        else if (click_id == 4) {
            // console.log(this.props)
            // this.props.history.push('/user/add-user/' + userid);
        }
        this.setState({ menuState: false });
    };
    closeDialog = (data) => {
        this.setState({ openNotesDialog: false });
        this.setState({ openDeleteDialog: false });
    }
    constructor(props, context) {
        super(props, context);

        this.state = {
            anchorEl: undefined,
            menuState: false,
            openNotesDialog: false,
            openDeleteDialog: false,
            order: 'asc',
            //orderBy: 'calories',
            orderBy: 'agenda',
            data: [],
            page: 0,
            rowsPerPage: 20,
            agendaitem: null,
        };
    }

    render() {
        const { filterText } = this.props
        const { menuState, anchorEl, data, order, orderBy, selected, rowsPerPage, page } = this.state;
        this.state.data = this.props.data
        // console.log('DataTable', this.state.data)
        return (
            <Paper>
                <div className="flex-auto">
                    <div className="table-responsive-material">
                        <Table className="">
                            <DataTableHead
                                order={order}
                                orderBy={orderBy}
                                onRequestSort={this.handleRequestSort}
                                rowCount={this.state.data ? this.state.data.length : 0}
                            />
                            <TableBody>
                                {/* {console.log('this.state.agendaitem', this.state.agendaitem)} */}
                                {!this.state.data ?
                                    <TableRow>
                                        <TableCell colSpan={6}/>
                                    </TableRow>
                                    :
                                    this.state.data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((n, index) => {
                                        return (
                                            (!filterText) || (filterText.length > 0 &&
                                                ((n.agenda && n.agenda.toLowerCase().indexOf(filterText) >= 0)
                                                    || (n.headed_by && n.headed_by.toLowerCase().indexOf(filterText) >= 0)
                                                    || (n.created_on && moment(n.created_on).format('DD/MM/YYYY').indexOf(filterText) >= 0)
                                                )) ?
                                                <TableRow
                                                    hover
                                                    role="checkbox"
                                                    tabIndex={-1}
                                                    key={n.id}
                                                >
                                                    <TableCell padding="checkbox">{(index + 1) + (page * rowsPerPage)}</TableCell>
                                                    <TableCell padding="none">{n.agenda}</TableCell>
                                                    <TableCell padding="none">{n.headed_by}</TableCell>
                                                    <TableCell padding="none">{moment(n.created_on).format('DD/MM/YYYY')}</TableCell>
                                                    <TableCell padding="none">{n.priority}</TableCell>
                                                    <TableCell padding="none">
                                                        <IconButton aria-label="view" onClick={this.onOptionMenuSelect.bind(this, n)}>
                                                            <i className="zmdi zmdi-more-vert"></i>
                                                        </IconButton>
                                                    </TableCell>
                                                    <TableCell padding="none">
                                                        <IconButton className="size-30" onClick={() => this.openNotes(n)}>
                                                            <SpeakerNotes /></IconButton>
                                                    </TableCell>
                                                </TableRow>
                                                : null
                                        );
                                    })}
                            </TableBody>
                            <TableFooter>
                                <TableRow>
                                    <TablePagination
                                        count={this.state.data ? this.state.data.length : 0}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        rowsPerPageOptions={[20, 40, 100]}
                                    />
                                </TableRow>
                            </TableFooter>
                        </Table>
                        <CardMenu menuState={menuState} anchorEl={anchorEl}
                            handleRequestClose={this.handleRequestClose.bind(this, this.state.agendaitem)} />
                        {this.state.openNotesDialog && <AgendaNotes open={this.state.openNotesDialog} id={this.state.agendaitem ? this.state.agendaitem.id : null}
                            notes={this.state.agendaitem ? this.state.agendaitem.notes : ''} closeDialog={this.closeDialog}
                            smeetingId={this.state.agendaitem ? this.state.agendaitem.supermeeting : null} committee_id={this.state.agendaitem ? this.state.agendaitem.undercommittee : null} />}
                        <DeleteAgendaItem open={this.state.openDeleteDialog} id={this.state.agendaitem ? this.state.agendaitem.id : null}
                            smeetingId={this.state.agendaitem ? this.state.agendaitem.supermeeting : null} closeDialog={this.closeDialog} committee_id={this.state.agendaitem ? this.state.agendaitem.undercommittee : null} />
                    </div>
                </div>
            </Paper>
        );
    }
}

export default withRouter(DataTable);


// WEBPACK FOOTER //
// ./app/agendaitemdetails/agendaitemlist/datatable.js